module.exports = __webpack_public_path__ + "static/media/41-10.251cf5ce.mp3";